import { useParams } from 'react-router';
import { useGetFinanceProductQuery } from '../../../api/queries/getFinanceProduct';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import FinanceProductDetailsInnerPage from './FinanceProductDetailsInnerPage';

const FinanceProductDetailsPage = () => {
    const { productId } = useParams<{ productId: string }>();

    const { data, loading } = useGetFinanceProductQuery({
        fetchPolicy: 'network-only',
        variables: { id: productId },
    });

    const product = data?.product;

    if (!product && loading) {
        return <LoadingElement />;
    }

    if (!product) {
        return <NotFoundResult />;
    }

    return <FinanceProductDetailsInnerPage product={product} />;
};

export default FinanceProductDetailsPage;
